<template>
  <div class="margin-bottom default-forms">
    <f7-row class="row-items-center">
      <f7-col width="40">
        <div class="dx-field">
          <div class="dx-field-label">Unidad de aplicación</div>
          <div class="dx-field-value">
            <DxSelectBox
              :items="applyUnit"
              v-model="period.default_apply_unit"
              displayExpr="name"
              valueExpr="id"
              :on-value-changed="onChangeApplyUnit"
            />
          </div>
        </div>
      </f7-col>
      <f7-col width="20"></f7-col>
      <f7-col width="40">
        <div class="dx-field justify-end">
          <div class="dx-field-label align-right" style="width: 40% !important;">Velocidad de avance</div>
          <div class="dx-field-value">
            <DxNumberBox v-model="treatmentPlan.forward_speed" />
          </div>
          <div class="margin-right margin-left">km/h</div>
        </div>
      </f7-col>
    </f7-row>
  </div>
</template>

<script>
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import { mapState } from "vuex";
import DxNumberBox from "devextreme-vue/number-box";

export default {
  name: "TreatmentStepTwoFormDefault",
  components: {
    DxSelectBox,
    DxTextBox,
    DxNumberBox
  },
  props: {
    period: {
      type: Object,
      default: () => {},
    },
    selectedIndex: Number,
  },
  data() {
    return {
      applyUnit: [
        {
          id: "default",
          name: "Defecto"
        },
        {
          id: "Kg-L / planta",
          name: "Kg-L / planta"
        }
      ],
    };
  },
  computed: {
    ...mapState("treatmentStepper", ["treatmentPlan"]),
  },
  methods: {
    onChangeApplyUnit(e) {
      let index = 0;
      let count = this.selectedIndex;

      for (const period of this.treatmentPlan.periods) {
        const doseVolumeNotEmpty = period.products.some(
          ({ dose_volume, active }) => (dose_volume > 0 && active)
        );

        if (doseVolumeNotEmpty) {
          if (count === 0) {
            break;
          }

          count--;
        }
        index++;
      }

      this.treatmentPlan.default_apply_unit.splice(
        index,
        1,
        e.value
      );
    },
  },
};
</script>

<style src="./TreatmentStepTwoForms.styles.scss" scoped lang="scss"></style>